import React, { useState, useEffect, useRef } from "react";
import DatePicker from "reactstrap-date-picker";
import { useAlert } from "react-alert";
import { constants } from "../../types/constants";

const DateCell = ({
  value: initialValue,
  row: { index, original },
  column: { id },
  updateMyData,
  changeTrigger,
}) => {
  const [value, setValue] = useState(initialValue || '');

  const dateChangeHandler = (e, t) => {
    if(changeTrigger)
      changeTrigger(original?.id, e);
    updateMyData(index, id, e);
    // if(dateECanBeChanged)
    //   setDateEValue(e);
  };

  // const onBlur = () => {
  //   updateMyData(index, id, value);
  // };

  // const handleKeyDown = (event) => {
  //   if (event.key === 'Enter') {
  //     event.target.blur();
  //   }
  // }

  // React.useEffect(() => {
  // }, [value]);

  useEffect(() => {
    setValue(initialValue || '')
  }, [initialValue])

  return <DatePicker id={`table_datepicker_${id}_${index}`}
    value={value}
    dateFormat={constants.DP_DATE_FORMAT}
    dayLabels={constants.DP_DAYS}
    monthLabels={constants.DP_MONTHS}
    weekStartsOn={constants.DP_WEEK_START}
    onChange={(v,f) => dateChangeHandler(v, f)}
    disabled={false} />

  // return <input type={isNumeric ? "number" : "text"} pattern={isNumeric ? "[0-9]*" : ""} className="editableCell form-control" value={value} onChange={onChange} onBlur={onBlur} />;
  // return addInitialValue ? (
  //   <InputGroup className={isPrice ? "editableCellPrice" : "editableCell"}>
  //     <Input type={isNumeric ? "number" : "text"} innerRef={valueRef} pattern={isNumeric ? "[0-9]*" : undefined} className="form-control" style={color ? {color: color} : {}} value={value} onChange={onChange} onBlur={onBlur} onFocus={onFocus} onKeyDown={handleKeyDown} />
  //     <InputGroupAddon addonType="append">
  //       <InputGroupText>({isDouble ? (maximumToShow ? maximumToShow.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + (isPrice ? " Dh" : "") : "-") : (original.QTE_INIT || "-")})</InputGroupText>
  //     </InputGroupAddon>
  //   </InputGroup>
  // ) : isDouble ? (
  //   <InputGroup className={isPrice ? "editableCellPrice" : "editableCell"}>
  //     <Input type="text" innerRef={valueRef} className="form-control" value={value} onChange={onChange} onBlur={onBlur} onFocus={onFocus} onKeyDown={handleKeyDown} />
  //     {!!isPrice && <InputGroupAddon addonType="append">
  //       <InputGroupText>DH</InputGroupText>
  //     </InputGroupAddon>}
  //   </InputGroup>
  // ) : <input type={isNumeric ? "number" : "text"} ref={valueRef} pattern={isNumeric ? "[0-9]*" : undefined} className="editableCellInput form-control" style={color ? {color: color} : {}} value={value} onChange={onChange} onBlur={onBlur} onFocus={onFocus} onKeyDown={handleKeyDown} />
};

export default DateCell;
